const words = [
    'を',
    'です',
    'する',
    'の',
    'られ',
];
export default words;
//# sourceMappingURL=japanese.js.map